import { CartLinesUpdateEvent } from '@shopify/events';

/* Agregar al carro desde las tarjetas Forno sin salir de la página:
   usa el mismo evento que el formulario de producto de Horizon, así el
   contador del carro y el carro lateral se actualizan solos. */
const CHECK = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path class="fd-check" d="M5 12.5l4.5 4.5L19 7.5"></path></svg> Agregado';
const ROOT = window.Shopify?.routes?.root || '/';

document.addEventListener('submit', (event) => {
  const form = event.target instanceof HTMLFormElement ? event.target : null;
  if (!form || !form.classList.contains('fd-add')) return;
  event.preventDefault();

  const button = form.querySelector('button');
  const label = button.dataset.label || (button.dataset.label = button.innerHTML);
  const data = new FormData(form);
  const id = Number(data.get('id'));
  const quantity = Number(data.get('quantity')) || 1;

  // Respuesta inmediata: el check aparece al toque, la llamada sigue en segundo plano.
  clearTimeout(button._fdTimer);
  button.classList.add('is-added');
  button.innerHTML = CHECK;
  button._fdTimer = setTimeout(() => {
    button.classList.remove('is-added');
    button.innerHTML = label;
  }, 1400);

  const deferred = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(id), quantity }],
      promise: deferred.promise,
    })
  );

  fetch(`${ROOT}cart/add.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id, quantity }] }),
  })
    .then(async (res) => {
      if (!res.ok) throw new Error((await res.json())?.description || 'No se pudo agregar');
      return fetch(`${ROOT}cart.js`).then((r) => r.json());
    })
    .then((cart) =>
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'forno-card', itemCount: quantity },
      })
    )
    .catch((error) => {
      deferred.reject?.(error);
      clearTimeout(button._fdTimer);
      button.classList.remove('is-added');
      button.innerHTML = 'No se pudo agregar';
      button._fdTimer = setTimeout(() => (button.innerHTML = label), 2000);
    });
});

/* Botón volver arriba */
const top = document.querySelector('.fd-top');
if (top) {
  const toggle = () => top.classList.toggle('is-on', window.scrollY > 500);
  addEventListener('scroll', toggle, { passive: true });
  toggle();
}

/* Filtros de colección: se aplican al cambiar, sin botón */
const filters = document.getElementById('fd-filters');
if (filters) {
  let t;
  const go = () => {
    clearTimeout(t);
    t = setTimeout(() => filters.requestSubmit(), 250);
  };
  filters.addEventListener('change', go);
  document.querySelector('select[form="fd-filters"]')?.addEventListener('change', go);
}

/* Carro: cambiar cantidades sin recargar y volver a pintar la sección */
const cartSection = document.getElementById('fd-cart');
if (cartSection) {
  const sectionId = cartSection.dataset.section;
  cartSection.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-qty]');
    if (!btn) return;
    const line = btn.closest('.fd-line');
    const quantity = Math.max(0, Number(btn.dataset.qty));
    line.classList.add(quantity === 0 ? 'is-leaving' : 'is-busy');
    const deferred = CartLinesUpdateEvent.createPromise();
    cartSection.dispatchEvent(
      new CartLinesUpdateEvent({ action: 'update', context: 'cart', lines: [], promise: deferred.promise })
    );
    try {
      const res = await fetch(`${ROOT}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: line.dataset.key, quantity, sections: [sectionId] }),
      });
      const cart = await res.json();
      deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'forno-cart' } });
      const html = cart.sections?.[sectionId];
      if (html) {
        const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('fd-cart');
        if (fresh) cartSection.innerHTML = fresh.innerHTML;
      } else {
        location.reload();
      }
    } catch (error) {
      deferred.reject?.(error);
      location.reload();
    }
  });
}
